import { gql } from "@apollo/client";

export const CREATE_EQUIPMENT_REQUEST = gql`
    mutation createEquipmentRequest($job: Int!, $items: [EquipmentRequestItemInputType]!, $notes: String, $truck: ID!) {
        createEquipmentRequest(job: $job, items: $items, notes: $notes, truck: $truck) {
            equipmentRequest {
                id
            }
        }
    }
`
